import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["events", "button"]

  toggle() {
    const isOpen = this.eventsTarget.classList.toggle("hidden") === false

    this.buttonTarget.textContent = isOpen ? "Show less" : "View more"
    this.buttonTarget.setAttribute("aria-expanded", isOpen)
  }
}
